import React from 'react';
import PropTypes from 'prop-types';
import { Pie } from '@ant-design/charts';

const SimplePie = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: 20 }}>Aucune donnée</div>
    );
  }

  const config = {
    data,
    angleField: 'percent',
    colorField: 'item',
    color: ['#80C0E9', '#F4E04D', '#FAA613', '#4F518C'],
    radius: 0.75,
    innerRadius: 0,
    label: false,
    legend: false,
    tooltip: false,
    pieStyle: {
      lineWidth: 1,
      stroke: '#fff'
    },
    interactions: [
      {
        type: 'element-selected'
      }
    ],
    autoFit: false,
    width: 80,
    height: 80
  };

  return (
    <div style={{ width: '80px', height: '80px', margin: '0 auto' }}>
      <Pie {...config} />
    </div>
  );
};

SimplePie.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      item: PropTypes.string,
      percent: PropTypes.number
    })
  )
};

SimplePie.defaultProps = {
  data: []
};

export { SimplePie };
